import { render, staticRenderFns } from "./tibet.vue?vue&type=template&id=b13887a0&scoped=true&"
import script from "./tibet.vue?vue&type=script&lang=js&"
export * from "./tibet.vue?vue&type=script&lang=js&"
import style0 from "./tibet.vue?vue&type=style&index=0&id=b13887a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../layers/paketo-buildpacks_npm-install/build-modules/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13887a0",
  null
  
)

export default component.exports